let Layout = {
    store: {
        namespaced: true
    },
    components: {},
    api: {}
};